var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"text-align":"center","padding":"40rem 0","color":"red","background-color":"#fff"}},[_vm._v(" 未完成此工作 ")])])
}]

export { render, staticRenderFns }